import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import MobileBottomSheet from '@/components/@IntranetLibrary/MobileBottomSheet';
import BoardDetailComment from '@/components/Board/BoardDetail/Feedback/BoardDetailComment';
import MobileCommentLikeSection from './MobileCommentLikeSection';

type MobileCommentSheetProps = {
  open: boolean;
  documentId: string;
  commentGroupId: string;
  isLike: boolean;
  isLikePending?: boolean;
  disabled?: boolean;
  onLikeClick?: () => void;
  onChangeCount?: (count: number) => void;
  handleComment?: (isComment: boolean, commentCount: number) => void;
  onClose: () => void;
};

// MUI Modal (BoardDetailModal) has z-index 1300
// Use 1400 to ensure drawer appears above the modal (same as AttachmentSheet)
const MOBILE_COMMENT_SHEET_Z_INDEX = 1400;

// Content wrapper: flex column fills drawer height
const SheetContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
});

// Like summary section at top (fixed, non-scrolling)
const LikeSummarySection = styled(Box)({
  padding: '16px 20px',
  backgroundColor: 'var(--dk-bg, #FFFFFF)',
  flexShrink: 0,
  borderTop: '1px solid var(--dk-line, #E7E9EC)',
});

// Divider between like section and comment section
const Divider = styled(Box)({
  height: '8px',
  backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
  flexShrink: 0,
});

// Scrollable comment section with 64px bottom padding
const CommentSection = styled(Box)({
  flex: 1,
  overflow: 'auto',
  padding: '16px 20px 64px',
});

const MobileCommentSheet = ({
  open,
  documentId,
  commentGroupId,
  isLike,
  isLikePending,
  disabled,
  onLikeClick,
  onChangeCount,
  handleComment,
  onClose,
}: MobileCommentSheetProps) => {
  return (
    <MobileBottomSheet
      open={open}
      height="auto"
      maxHeight="calc(100dvh - 96px)"
      onClose={onClose}
      zIndex={MOBILE_COMMENT_SHEET_Z_INDEX}
      showHandle={true}
      notifyAppBar
    >
      <SheetContent>
        <LikeSummarySection>
          <MobileCommentLikeSection
            documentId={documentId}
            isLike={isLike}
            isLikePending={isLikePending}
            disabled={disabled}
            onLikeClick={onLikeClick}
          />
        </LikeSummarySection>
        <Divider />
        <CommentSection>
          <BoardDetailComment
            commentGroupId={commentGroupId}
            disabled={disabled}
            inputStyle="sheet"
            service="board"
            onChangeCount={onChangeCount}
            handleComment={handleComment}
          />
        </CommentSection>
      </SheetContent>
    </MobileBottomSheet>
  );
};

export default MobileCommentSheet;
